module.exports = __webpack_public_path__ + "static/bg3-a5ed1e7e6ee497cb17df8ee8e2f31ff7.png";